<template>
  <div class="diet-navigation-buttons">
    <Tooltip placement="bottom-end">
      <template #trigger>
        <StyledButton
          :disabled="!previousDietId"
          variant="secondary"
          left-icon="chevron_left"
          class="min-w-0"
          @click="handlePreviousClick"
        />
      </template>
      {{ previousTooltipText }}
    </Tooltip>
    <Tooltip placement="bottom-end">
      <template #trigger>
        <StyledButton
          :disabled="!nextDietId"
          variant="secondary"
          left-icon="chevron_right"
          class="min-w-0"
          @click="handleNextClick"
        />
      </template>
      {{ nextTooltipText }}
    </Tooltip>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import { StyledButton } from '@/components/StyledButton'
  import { Tooltip } from '@/components/ui'

  const props = defineProps<{
    nextDietId: number | null
    previousDietId: number | null
  }>()

  const emit = defineEmits<{
    select: [dietId: number]
  }>()

  const previousTooltipText = computed(() => {
    if (!props.previousDietId) {
      return 'Brak wcześniejszych jadłospisów'
    }
    return 'Poprzedni jadłospis z datą'
  })

  const nextTooltipText = computed(() => {
    if (!props.nextDietId) {
      return 'Brak późniejszych jadłospisów'
    }
    return 'Następny jadłospis z datą'
  })

  function handlePreviousClick() {
    if (props.previousDietId) {
      emit('select', props.previousDietId)
    }
  }

  function handleNextClick() {
    if (props.nextDietId) {
      emit('select', props.nextDietId)
    }
  }
</script>

<style scoped>
  .diet-navigation-buttons {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }
</style>
